import React from 'react';
import LoginBox from './login-box';
import NotificationBar from '../shared/notification-bar';
import linkedin from '../../assets/images/linkedin_icon.png'
import insta from '../../assets/images/instagram_icon.png'

const Login = ({ error, setEmail, setPassword, authenticate }) => {
  return (
    <div className='login'>
      {error && <NotificationBar errorMessage={error} />}
      <LoginBox
        setEmail={setEmail}
        setPassword={setPassword}
        authenticate={authenticate}
      />
      <div className='login-social'>
        <a href='https://de.linkedin.com/company/aposphaere' target='_blank'><img src={linkedin} alt='LinkedIn' className='login-social-icon'/>
        </a>
      </div>
    </div>
  );
};

export default Login;
